export class FiltroPremiacaoCidadao {
    public consumidorId: number;
    public page: number;
    public pageSize: number;
  }


// WEBPACK FOOTER //
// ./src/app/shared/model/filtro-premiacao-cidadao.ts